const config = {
    host: (process.env.NODE_ENV === 'production') ? 'https://tuktuk.dvgeo.app' : 'http://192.168.100.106:3024',
    homePage: (process.env.NODE_ENV === 'production') ? 'https://tuktuk.dvgeo.app' : 'http://192.168.100.106:3024',
    api: 'api/',
    apiSocket: 'tuktuk::1.2',
    nameDir: 'tuktuk',
    package: 'ec.tuktuk.web',
    version: '1.0.1',
    googleAPIKey: 'AIzaSyDx4GuX4IeqWUZ2mV04QDT6ClktDIH1yS8',
    appName: 'TUK TUK',
    provider: '',
    colorPrimary: '#000000',
    colorDark: '#000000',
    colorAccent: '#ccc',
    colorTextPrimary: '#fff',
    colorTextDark: '#000',
    playStorePassengerId: 'ec.tuktuk.passenger',
    playStoreDriverId: 'ec.tuktuk.driver',
    appStorePassengerId: '6759986542',
    appStoreDriverId: '6759986706',
};
export default config;
